import React from 'react';

import { Flex } from '@chakra-ui/react';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { Radio } from 'uiToolkitV1/Radio';
import { Tooltip } from 'uiToolkitV1/Tooltip';

export const ParentOKRSelectionRadioButton = ({
  rowData,
  selectedParentUuid /* selectedParentUuid is the uuid of okr which is selected by user to new parent */,
  setSelectedParentUuid: setSelectedParent,
}) => {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();
  const isSelected = selectedParentUuid === rowData.uuid;

  const isDisabled = false;
  const disabledReason = ``;

  const handleSelection = () => {
    const { uuid, title: text, type, visibilityType, progressType, metric: measure, metricName: measureType } = rowData;

    setSelectedParent({
      uuid,
      text,
      type,
      visibilityType,
      /* setting following only to be used in createNewOKRWorkflow */
      progressType,
      measure,
      measureType,
    });
  };

  return (
    <Flex w="100%" h="100%">
      <Tooltip fontSize="14px" label={isDisabled ? disabledReason : `Select this ${moduleName}`}>
        <Flex alignItems="center">
          <Radio isChecked={isSelected} isDisabled={isDisabled} name={rowData.uuid} onClick={handleSelection} />
        </Flex>
      </Tooltip>
    </Flex>
  );
};
